<template>
  <div class="flex justify-center items-center h-screen w-full bg-gray-800">
    <!-- Tarjeta con animación de entrada -->
    <div
      class="bg-white p-8 rounded-2xl w-80 space-y-6 shadow-lg animate-[fadeIn_0.5s_ease-out]"
    >
      <!-- Logo con animación sutil -->
      <div class="flex justify-center mb-4 animate-[bounceIn_0.6s_ease-out]">
        <img
          src="/indagro.png"
          alt="Logo Indagro"
          class="w-20 h-20 object-contain hover:scale-105 transition-transform"
        />
      </div>

      <h2
        class="text-center text-2xl font-semibold text-gray-800 animate-[fadeIn_0.7s_ease-out]"
      >
        Iniciar Sesión
      </h2>

      <!-- Formulario con efectos mejorados -->
      <div class="space-y-5">
        <div class="relative group">
          <input
            v-model="usuario"
            type="text"
            @input="handleInput"
            class="w-full p-3 bg-gray-50 text-gray-800 border-0 border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none rounded-t-lg peer"
          />
          <label
            class="absolute left-3 top-3 text-gray-500 text-sm transition-all duration-200 transform origin-left pointer-events-none"
            :class="{
              'translate-y-[-18px] scale-75 text-blue-500': usuario,
              'peer-focus:translate-y-[-18px] peer-focus:scale-75 peer-focus:text-blue-500':
                !usuario,
            }"
          >
            Usuario
          </label>
          <div
            class="h-0.5 bg-blue-500 scale-x-0 group-focus-within:scale-x-100 transition-transform duration-300 origin-left"
          ></div>
        </div>

        <div class="relative group">
          <input
            v-model="clave"
            type="password"
            @input="handleInput"
            class="w-full p-3 bg-gray-50 text-gray-800 border-0 border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none rounded-t-lg peer"
          />
          <label
            class="absolute left-3 top-3 text-gray-500 text-sm transition-all duration-200 transform origin-left pointer-events-none"
            :class="{
              'translate-y-[-18px] scale-75 text-blue-500': clave,
              'peer-focus:translate-y-[-18px] peer-focus:scale-75 peer-focus:text-blue-500':
                !clave,
            }"
          >
            Contraseña
          </label>
          <div
            class="h-0.5 bg-blue-500 scale-x-0 group-focus-within:scale-x-100 transition-transform duration-300 origin-left"
          ></div>
        </div>
      </div>

      <p
        v-if="errorMessage"
        class="text-xs text-center py-2 px-3 bg-red-50 text-red-600 rounded-lg animate-[shake_0.4s_ease-in-out]"
      >
        {{ errorMessage }}
      </p>

      <button
        @click="login"
        class="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-[1.02] flex justify-center items-center shadow-md hover:shadow-lg"
        :disabled="loading"
      >
        <span v-if="!loading" class="block">Ingresar</span>
        <svg
          v-else
          class="animate-spin h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usuario: "",
      clave: "",
      errorMessage: "",
    };
  },
  methods: {
    login() {
      this.$axios
        .post("/login", {
          usuario: this.usuario,
          clave: this.clave,
        })
        .then((response) => {
          alert(response.data.message);
          localStorage.setItem("token", response.data.access_token);
          this.$axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.access_token}`;
          this.$router.push("/");
        })
        .catch((error) => {
          this.errorMessage =
            error.response?.data?.message ||
            "Ocurrió un error al iniciar sesión.";
        });
    },
  },
  mounted() {
    const token = localStorage.getItem("token");

    if (token) {
      this.$axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      this.$axios
        .get("/user")
        .then(() => {
          this.$router.push("/");
        })
        .catch((error) => {
          if (error.response?.status === 403) {
            localStorage.removeItem("token");
          }
        });
    }
  },
};
</script>
